import { render } from "./VisualHooks.vue?vue&type=template&id=4233ba32"
import script from "./VisualHooks.vue?vue&type=script&lang=js"
export * from "./VisualHooks.vue?vue&type=script&lang=js"

import "./VisualHooks.vue?vue&type=style&index=0&id=4233ba32&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__